// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___jVPf","questions":"styles_questions__1uALF","footer":"styles_footer__1mzlL"};